<template >
  <div>
    <!--      顶部头样式-->
    <div id="header">
      <div class="myheader">
        <div>
          <span @click="goback()" class="left">
            <Icon style="color:#fff" type="md-arrow-round-back" />
          </span>
          <span class="wei">{{title}}</span>
          <span @click="menushowact" class="right" v-show="tabshow">
            <Icon style="color: #fff;" type="md-more" />
          </span>
        </div>
      </div>
    </div>
    <!--    微信的悬浮球-->
    <div id="ball">
      <div
        class="ys-float-btn"
        :style="{'width':itemWidth+'px','height':itemHeight+'px','right':right+'px','top':top+'px','margin-top':'30px'}"
        ref="div"
      >
        <slot name="icon"></slot>
        <p>
          <!-- <img src="../../../static/img/gd@2x.png" @click="menushowact"  id="more"/> -->
          <img :src="imgpath.qiu" @click="menushowact" id="more" />
        </p>
      </div>
    </div>

    <!-- 以下为菜单 -->
    <ul
      @click="menushowact"
      class="menu"
      :style="{'right':menuRight,'left':menuLeft,'top':menuTop,'bottom':menuBottom}"
      v-show="menushow"
    >
      <router-link tag="li" to="/index">
        <Icon class="color" type="md-home"></Icon>{{$t('m.HomePage')}}
      </router-link>
      <router-link tag="li" to="/attendmeeting">
        <Icon class="color" type="md-people"></Icon>{{$t('m.PlanMeeting')}}
      </router-link>
      <router-link tag="li" to="/forthmeetingvmr">
        <Icon class="color" type="md-person-add"></Icon>{{$t('m.ControlMeeting')}}
      </router-link>
      <router-link tag="li" :to="{path:'/wxLogin',query:{key:wx_key, gotoScan:'true', type:'signIn'}}">
        <Icon class="color" type="md-expand"></Icon>{{$t('m.ScanCodeCheckin')}}
      </router-link>
      <router-link tag="li" to="/resetpassword" v-if="login==whoShowHeader">
        <Icon class="color" type="md-lock"></Icon>{{$t('m.MofifyPass')}}
      </router-link>
      <router-link tag="li" to="/usermessage" v-if="login==whoShowHeader">
        <Icon class="color" type="md-person"></Icon>{{$t('m.PersonProfile')}}
      </router-link>
      <li @click="model=true">
        <Icon class="color" type="md-shirt"></Icon>{{$t('m.ChangeSkin')}}
      </li>
      <router-link tag="li" to="/help">
        <Icon class="color" type="md-help-circle"></Icon>{{$t('m.Help')}}
      </router-link>
      <li @click="exit()" v-if="login==whoShowHeader">
        <Icon class="color" type="ios-log-in"></Icon>{{$t('m.Exit')}}
      </li>
    </ul>

    <!-- 以下为换肤弹窗 -->
    <div class="modelwrap" v-if="model">
      <div class="model">
        <div class="modeltitle">{{$t('m.ChangeSkin')}}</div>
        <div class="modelcontent">
          <div :class="{skin:true,green:style=='green'}">
            <div @click="changestyle('green')" class="circle green"></div>
          </div>
          <div :class="{skin:true,blue:style=='blue'}">
            <div @click="changestyle('blue')" class="circle blue"></div>
          </div>
          <div :class="{skin:true,gre:style=='grep'}">
            <div @click="changestyle('grep')" class="circle gre"></div>
          </div>
          <div :class="{skin:true,black:style=='black'}">
            <div @click="changestyle('black')" class="circle black"></div>
          </div>
        </div>
        <div @click="model=false" class="modelact color">OK</div>
      </div>
    </div>

    <!--    <div style="height:44px;"></div>-->
    <waitcheck v-if="waitcheckshow"></waitcheck>
  </div>
</template>
<script>
import { changeskin, usermessage, logout } from "../../assets/js/url";

import waitcheck from "../content/waitcheck";
export default {
  name: "myheader",
  props: {
    title: String,
    type: String, //用于区分首页要不要显示黑框，如有有这个值就显示，没有这个值就通过session判断
    text: {
      type: String,
      default: "默认文字"
    },
    itemWidth: {
      type: Number,
      default: 50
    },
    itemHeight: {
      type: Number,
      default: 50
    },
    gapWidth: {
      type: Number,
      default: 10
    },
    coefficientHeight: {
      type: Number,
      default: 0.1
    },
    coefficientWidth: {
      type: Number,
      default: 0.1
    },
    menuWidth: {
      //menu的宽度，是px单位的不行，怎么转为rem
      type: Number,
      default: 450
    }
  },
  data() {
    return {
      menushow: false,
      model: false,
      tabshow: false, //黑框右侧的三点显示
      usermessage: "",
      waitcheckshow: false,
      //判断登陆的类别
      login: "mobile",
	  wx_key: "",
      whoShowBall: "wechat",
      whoShowHeader: "mobile",
      //微信球的位置
      timer: null,
      currentTop: 0,
      clientWidth: 0,
      clientHeight: 0,
      right: 0,
      top: 0,
      //菜单的位置
      menuRight: "",
      menuLeft: "",
      menuTop: "",
      menuBottom: "",
      //横竖屏的状态
      Screenstatus: true
    };
  },
  created() {
    console.log(this.top)
  },
  mounted() {
    window.addEventListener(
      "onorientationchange" in window ? "orientationchange" : "resize",
      this.detectOrient,
      false
    );
  },
  activated() {
    this.login = window.sessionStorage.getItem("login");
	this.wx_key = window.sessionStorage.getItem("wx_key");
    if (this.type == "login") {
      //有这个type的要显示黑框，没有的通过session判断
      var header = document.getElementById("header");
      header.style.display = "block";
      var ball = document.getElementById("ball");
      ball.style.display = "none";
    } else {
      //如果要显示球的，把头去掉
      if (this.login != null && this.login == this.whoShowBall) {
        var header = document.getElementById("header");
        header.style.display = "none";
        header.style.height = "0";
        var ball = document.getElementById("ball");
        ball.style.display = "block";
        //----1.初始化球的一些参数
        this.clientWidth = document.documentElement.clientWidth; //可见区域宽度
        this.clientHeight = document.documentElement.clientHeight; //可见区域高度
        this.right = this.gapWidth;
        this.top = this.clientHeight * this.coefficientHeight;
        //---2.球的移动逻辑---注册事件-----------
        window.addEventListener("scroll", this.handleScrollStart);
        this.$nextTick(() => {
          const div = this.$refs.div;
          div.addEventListener("touchstart", () => {
            div.style.transition = "none";
          });
          div.addEventListener("touchmove", e => {
            if (this.menushow == true) this.menushow = !this.menushow; //移动过程中把菜单收起来
            if (e.targetTouches.length === 1) {
              let touch = event.targetTouches[0];
              this.right =
                this.clientWidth - (touch.clientX + this.itemWidth / 2);
              this.top = touch.clientY - this.itemHeight / 2;
            }
          });
          div.addEventListener("touchend", () => {
            div.style.transition = "all 0.3s";
            //限定悬浮球的上下左右位置
            if (this.right < this.clientWidth * this.coefficientWidth)
              this.right = this.gapWidth;
            else if (
              this.right >
              this.clientWidth * (1 - this.coefficientWidth)
            )
              this.right = this.clientWidth - this.itemWidth - this.gapWidth;
            if (this.top < this.clientHeight * this.coefficientHeight)
              this.top = this.clientHeight * this.coefficientHeight;
            else if (
              this.top >
              this.clientHeight * (1 - this.coefficientHeight)
            )
              this.top = this.clientHeight * (1 - this.coefficientHeight);
          });
        });
      } else if (this.login != null && this.login == this.whoShowHeader) {
        //要显示头部，通过判断
        var header = document.getElementById("header");
        header.style.display = "block";
        var ball = document.getElementById("ball");
        ball.style.display = "none";
      }
    }
    if (sessionStorage.getItem("UUID")) {
      this.getusermessage();
    }
    const path = this.$route.path;
    if (
      path != "/login" &&
      path != "/forgetpassword" &&
      path != "/register" &&
      path != "/resetpassword2"
    ) {
      const UUID =
        window.sessionStorage.getItem("UUID") || path == "/meetingdetail";
      if (UUID) {
        this.tabshow = true;
      } else {
        const _this = this;
        this.tabshow = false;
        _this.$router.push("/login");
      }
    }
  },

  beforeDestroy() {
    if (this.login != null && this.login == this.whoShowBall) {
      window.removeEventListener("scroll", this.handleScrollStart);
    }
  },
  computed: {
    imgpath() {
      return this.$store.state.imagestyle[this.$store.state.cssstyle];
    },
    style() {
      return this.$store.state.cssstyle;
    }
  },
  components: {
    waitcheck
  },
  methods: {
    detectOrient() {
      if (window.orientation === 180 || window.orientation === 0) {
        this.$store.commit("changeportrait", true);
      }
      if (window.orientation === 90 || window.orientation === -90) {
        this.$store.commit("changeportrait", false);
      }
    },
    //显示菜单
    menushowact() {
      //如果是球的要根据球的位置 确定菜单的位置
      if (this.login == this.whoShowBall) {
        //确定菜单的上下左右
        if (this.top < this.clientHeight / 2) {
          //在上半方
          this.menuTop = this.top + this.itemHeight + "px";
          this.menuBottom = "";
        } else {
          //在下方
          this.menuBottom = this.clientHeight - this.top + "px";
          this.menuTop = "";
        }
        if (this.right < this.clientWidth / 2) {
          //球在右侧
          this.menuLeft = "";
          this.menuRight = this.right + this.itemWidth + "px";
        } else {
          //在左侧
          this.menuRight = "";
          this.menuLeft = this.clientWidth - this.right + "px";
        }
      } else {
        //固定的头
        this.menuRight = "0.04rem";
        this.menuTop = "0.5rem";
      }
      clearTimeout(time);
      this.menushow = !this.menushow;
      const _this = this;
      var time = setTimeout(function() {
        _this.menushow = false;
      }, 3000);
    },
    goback() {
      this.$router.go(-1);
    },
    attendinit() {
      // 记录store归零，暂时不用
      this.$store.commit("setmeetingcfparty", "");
      this.$store.commit("setmeetingcfpartyname", "");
      this.$store.commit("setmeetingcfhost", "");
      this.$store.commit("setmeetingcfhostname", "");
      this.$store.commit("setmeetingcfparty", "");
      this.$store.commit("setmeetingcfparty", "");
      this.$store.commit("setmeetingcfterminal", "");
      this.$store.commit("setmeetingcfterminalname", "");
    },
    changestyle(style) {
      const num =
        style == "green" ? 1 : style == "blue" ? 2 : style == "grep" ? 3 : 4;
      this.$http
        .post(changeskin, {
          useruuid: window.sessionStorage.getItem("UUID"),
          action: 2,
          color: num
        })
        .then(skin => {
          if (skin.data.status == 2000) {
            this.$store.commit("changestyle", style);
          }
        });
    },
    getusermessage() {
      this.$http
        .post(usermessage, {
          useruuid: window.sessionStorage.getItem("UUID"),
          usertype: 2
        })
        .then(res => {
          this.usermessage = res.data.data;
          this.waitcheckshow = this.usermessage.status == 0;
        });
    },
    exit() {
      this.attendinit();
      this.$http
        .post(logout, {
          loginName: window.localStorage.getItem("loginName")
        })
        .then(res => {
          if (res.data.status == 2000) {
            window.sessionStorage.clear("UUID");
            window.localStorage.removeItem("loginName");
            window.localStorage.removeItem("password");
            this.$router.push("/login");
          }
        });
    }
  },

  //-----------悬浮球的-----------
  handleScrollStart() {
    this.timer && clearTimeout(this.timer);
    this.timer = setTimeout(() => {
      this.handleScrollEnd();
    }, 300);
    this.currentTop =
      document.documentElement.scrollTop || document.body.scrollTop;
    if (this.right > this.clientWidth / 2) {
      this.right = this.clientWidth - this.itemWidth / 2;
    } else {
      this.right = -this.itemWidth / 2;
    }
  },
  handleScrollEnd() {
    let scrollTop =
      document.documentElement.scrollTop || document.body.scrollTop;
    if (scrollTop === this.currentTop) {
      if (this.right > this.clientWidth / 2) {
        this.right = this.clientWidth - this.itemWidth - this.gapWidth;
      } else {
        this.right = this.gapWidth;
      }
      clearTimeout(this.timer);
    }
  }
};
</script>
<style scoped>
.myheader {
  height: 0.44rem;
  background: #202123;
  color: #fff;
  line-height: 0.44rem;
  text-align: center;
  font-size: 0.18rem;
  position: fixed;
  top: 0px;
  left: 0;
  width: 100%;
  z-index: 10000;
}
.acrossheader {
  height: 0.22rem;
  background: #202123;
  color: #fff;
  line-height: 0.22rem;
  text-align: center;
  font-size: 0.14rem;
  position: fixed;
  top: 0px;
  left: 0;
  width: 100%;
  z-index: 10000;
}
#header {
  display: none;
  height: 0.44rem;
}
#acheader {
  display: none;
  height: 0.44rem;
}
#ball {
  display: none;
}
.myheader .wei {
  font-family: PingFangSC-Regular;
  font-size: 0.18rem;
  color: #ffffff;
  letter-spacing: 1px;
  text-align: center;
  width: 70%;
}
.acrossheader .wei {
  font-family: PingFangSC-Regular;
  font-size: 0.12rem;
  color: #ffffff;
  letter-spacing: 1px;
  text-align: center;
  width: 70%;
}
.header i {
  font-size: 0.2rem;
  height: 0.44rem;
  line-height: 0.44rem;
}
.acrossheader i {
  font-size: 0.1rem;
  height: 0.22rem;
  line-height: 0.22rem;
}

.left {
  /* float: left;
        margin-left:0.20rem; */
  position: absolute;
  left: 0.2rem;
  top: 0;
}

.right {
  /* float: right;
        margin-right:0.15rem; */
  position: absolute;
  right: 0.15rem;
  top: 0;
}

.menu {
  width: 1.88rem;
  /*height: 4rem;*/
  border: 1px solid #e7eaee;
  background: #fff;
  padding: 0 0.15rem;
  box-sizing: border-box;
  /*position: absolute;*/
  position: fixed;
  /*top: 0.5rem;*/
  /*right: 0.04rem;*/
  color: #000;
  font-size: 0.14rem;
  text-align: left;
  border-radius: 3px;
  z-index: 1000;
}

.menu li {
  height: 0.35rem;
  border-bottom: 1px solid #e7eaee;
  line-height: 0.35rem;
}

i {
  margin-right: 5px;
}

.modelwrap {
  z-index: 999999;
  width: 100%;
  height: 100%;
  top: 0.44rem;
  left: 0px;
  position: fixed;
  background: rgba(0, 0, 0, 0.4);
}

.model {
  position: absolute;
  top: 50%;
  left: 50%;
  margin-top: -1.5rem;
  margin-left: -1.5rem;
  width: 3rem;
  height: 2rem;
  background-color: #fff;
  border-radius: 12px;
  box-sizing: border-box;
  padding: 0.2rem 0.06rem;
}

.modeltitle {
  text-align: center;
  height: 0.34rem;
  line-height: 0.34rem;
  font-size: 0.17rem;
  color: #000;
}

.modelcontent {
  height: 0.9rem;
  text-align: left;
  text-align: center;
}

.modelact {
  border-top: 1px solid #d9dde3;
  text-align: center;
  height: 0.4rem;
  line-height: 0.55rem;
  font-size: 0.17rem;
  color: #000;
}

.skin {
  width: 0.6rem;
  height: 0.6rem;
  box-sizing: border-box;
  border-radius: 100%;
  margin: 0 0.02rem 0.2rem;
  display: inline-block;
  position: relative;
}

.circle {
  width: 0.5rem;
  height: 0.5rem;
  box-sizing: border-box;
  position: absolute;
  top: 50%;
  left: 50%;
  margin-left: -0.25rem;
  margin-top: -0.25rem;
  border-radius: 100%;
  text-align: center;
  line-height: 0.5rem;
  font-size: 0.14rem;
  color: #fff;
}

.circle.green {
  background: #32af66 !important;
}

.circle.blue {
  background: #008ec3 !important;
}

.circle.gre {
  background: #515a69;
}

.circle.black {
  background: #000f18;
}

.skin.green {
  border: 0.02rem solid #32af66 !important;
}

.skin.blue {
  border: 0.02rem solid #008ec3 !important;
}

.skin.gre {
  border: 0.02rem solid #515a69;
}

.skin.black {
  border: 0.02rem solid #000f18;
}

/*  悬浮球的样式*/
.ys-float-btn {
  /* background:rgb(245, 7, 7);
    box-shadow:0 2px 10px 0 rgba(0,0,0,0.1); */
  /* border-radius:50%;
    color: #666666; */
  z-index: 999;
  transition: all 0.3s;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  position: fixed;
  bottom: 20vw;
  /* img{
      width: 50%;
      height: 50%;
      object-fit: contain;
      margin-bottom: 3px;
    } */

  /* p{
      font-size:7px;
    } */
}
i {
  font-size: 0.2rem;
  height: 0.44rem;
  line-height: 0.44rem;
}
</style>


// WEBPACK FOOTER //
// src/components/header/header.vue